import { defaultTranslations, translationsNamespace } from '../constants';
import { mainLogger } from '../logger';
export const getTranslationsProps = ({
  currentLanguage,
  staticApiUrl,
  tenant
}) => {
  const result = {
    clientFetchConfiguration: {
      baseUrl: staticApiUrl,
      onError: error => {
        mainLogger.error(error, {
          action: 'Loading translations.'
        });
      },
      tenant
    },
    currentLanguage,
    defaultTranslationsWithNamespaces: {
      [translationsNamespace]: defaultTranslations
    }
  };
  return result;
};